// extracted by mini-css-extract-plugin
module.exports = {"tags-container":"tags-m__tags-container__2X12X","tag-name":"tags-m__tag-name__pe-_S"};